var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMchoiceAnswerIncorrectIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2.5,
    fill: "#FF0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1452_4666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7553 14.8161C14.0482 15.109 14.5231 15.109 14.816 14.8161C15.1089 14.5232 15.1089 14.0484 14.816 13.7555L11.0606 10.0001L14.816 6.24469C15.1089 5.95179 15.1089 5.47692 14.816 5.18403C14.5231 4.89113 14.0482 4.89113 13.7553 5.18403L9.99992 8.93942L6.24453 5.18403C5.95164 4.89113 5.47676 4.89113 5.18387 5.18402C4.89098 5.47692 4.89098 5.95179 5.18387 6.24469L8.93926 10.0001L5.18387 13.7555C4.89098 14.0484 4.89098 14.5232 5.18387 14.8161C5.47676 15.109 5.95164 15.109 6.24453 14.8161L9.99992 11.0607L13.7553 14.8161Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1452_4666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(15 5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMchoiceAnswerIncorrectIc);
export default __webpack_public_path__ + "static/media/mchoice_answer_incorrect_ic.e714cf696710b32ac3c62eb5a3b03bbb.svg";
export { ForwardRef as ReactComponent };